module.exports = __webpack_public_path__ + "img/Klammeräffchen.af9fba44.svg";